// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"ad191676","outerContainer":"_6ede829d","secondaryToolbar":"c3efa2f1","doorHangerRight":"a3def979","toolbarContainer":"_5a227ad6","toolbarViewerMiddle":"_80334c6c","progressBar":"_5aaaee89","back-to-application":"_2c3037e1","root":"fa6d0cd0","danger":"af94f1f0","image":"b542490c","content":"_1e913ec2","heading":"_807d23e6","heading__title":"af8c79a0","heading__subtitle":"e7f1a9e3","heading__time":"_46b92fec","body":"e0eff1c4","deleted":"d562ee4a","action":"bc02641b","replies":"_1526aec8","previousLink":"_6c0f1dd4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment/index.styl
// module id = 1486
// module chunks = 39